import { Component, Input, OnInit } from '@angular/core';
import { IbMamService } from '../ib-mam.service';
import { AppService } from '../../../app.service';
import { Constants } from '../../../shared/utils/constants';
declare var $: any;

@Component({
  selector: 'app-mam-follower',
  templateUrl: './mam-follower.component.html',
  styleUrls: ['./mam-follower.component.sass'],
})
export class MamFollowerComponent implements OnInit {
  @Input() permission;
  condition: any = {
    keyword: '',
  };
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 50,
    totalRecord: 0,
  };
  data = [];
  dataSelected;
  conditionUpdate: any = {
    group: '',
  };
  constructor(private service: IbMamService, private appService: AppService) {}

  ngOnInit(): void {
    this.getMamFollowers();
  }
  search(event: any): void {
    if (event === 'click' || event.keyCode === 13) {
      this.pageInfo.pageIndex = 1;
      this.getMamFollowers();
    }
  }
  getMamFollowers(): void {
    const params = {
      q: this.condition.keyword
        ? encodeURIComponent(this.condition.keyword)
        : '',
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };
    this.service.getMamFollowers(params).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.data = res.data;
        this.pageInfo.totalRecord = res.paging.total;
      }
    });
  }
  getMamFollowerInfo(item): void {
    this.dataSelected = item;
  }
  processCloseAll(): void {
    const body = {
      login: this.dataSelected.login,
    };
    this.service.processCloseAllPosition(body).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.appService.showSuccess('Close all positions success');
        $('#modalMamFollower .close').trigger('click');
      }
    });
  }
  processApply(): void {
    if (!this.conditionUpdate.group) {
      this.appService.showError('Please choose group');
      return;
    }
    const body = {
      group_follower: this.conditionUpdate.group,
      login: this.dataSelected.login,
    };
    this.service.updateMamFollower(body).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.appService.showSuccess('Update group MAM follower success');
        $('#modalMamFollower .close').trigger('click');
      }
    });
  }
  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.getMamFollowers();
  }
}
